import ClientService from '../../services/client-service';
import getSearchResultDataQuery from '../../graphql/query/get-search-result-data.graphql';
import getSearchQuickResultDataQuery from '../../graphql/query/get-search-quick-result-data.graphql';

export default class SearchApi {
  public static getSearchResultData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getSearchResultDataQuery, payload);
  }

  public static getSearchQuickResultData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getSearchQuickResultDataQuery, payload);
  }
}
